import React, {useState} from 'react'

const ContactForm = ({ props }) => {
	var [formData, updateFormData] = useState({}), [showSuccess, toggleShowSuccess] = useState(false)

	function CheckFormValid(){
		var {fullName, phoneNumber, emailAddress} = formData;
		if(!fullName || !phoneNumber || !emailAddress){return false}; return true;
	}

	async function SendFormData(){
		var SEND_NEW_EMAIL = `mutation SendNewEmail($formData: FormDataInput){sendNewEmail(formData: $formData){ id }}`, serverUrl;

		if(process.env.REACT_APP_ENVIRONMENT === "production"){serverUrl = 'https://res302.herokuapp.com'} else {serverUrl = 'http://localhost:3001'}

		var query = JSON.stringify({query: SEND_NEW_EMAIL ,variables: { formData }}), response = await fetch(`${serverUrl}/graphql`, {headers: {'content-type': 'application/json'}, method: 'POST', body: query});

		await response.json().then(data => {
			if(data.errors){console.log('CreateDraftListing - An error occured ', data.errors)}
			else {
				updateFormData({});
				toggleShowSuccess(true);
				setTimeout(() => toggleShowSuccess(false), 10000);
			}
		});
	}

	return(
		<div className={`FlexContainer Flex Column SpaceAboveX4 SpaceBelowX8`}>
           <h2 className={`TextCentre`}>Let's talk</h2>

           <p className={`TextCentre SpaceAboveX4`}>Fill in the form below to register interest and/or request info</p>

           {!showSuccess
           		? 	<div className={`FlexContainer Column FullWidth`}>
						<div className={`FlexContainer RowToColumn Width80 SpaceBetween JustifyCentre MarginAuto SpaceAboveX2`}>
							<input className={`Flex SpaceRight-DT`} placeholder="Full name*" name="fullName" value={formData.fullName || ""} onChange={e => updateFormData({...formData, [e.target.name]: e.target.value})}/>
							<input className={`Flex SpaceLeft-DT SpaceAboveX2-MB`} placeholder="Phone number*" name="phoneNumber" value={formData.phoneNumber || ""} onChange={e => updateFormData({...formData, [e.target.name]: e.target.value})}/>
						</div>

						<div className={`FlexContainer RowToColumn Width80 SpaceBetween JustifyCentre MarginAuto SpaceAboveX2`}>
							<input className={`Flex SpaceRight-DT`} placeholder="Email address*" name="emailAddress" value={formData.emailAddress || ""} onChange={e => updateFormData({...formData, [e.target.name]: e.target.value})}/>
							<input className={`Flex SpaceLeft-DT SpaceAboveX2-MB`} placeholder="Subject" name="subject" value={formData.subject || ""} onChange={e => updateFormData({...formData, [e.target.name]: e.target.value})}/>
						</div>

						<div className={`FlexContainer RowToColumn Width80 SpaceBetween JustifyCentre MarginAuto SpaceAboveX2`}>
							<textarea className={`FullWidth`} cols="10" rows="4" placeholder="Comments/Enquiries" name="comments" value={formData.comments || ""} onChange={e => updateFormData({...formData, [e.target.name]: e.target.value})}/>
						</div>

						<button 
							className={`PillButton SuperRound Width80 MarginAuto SpaceAboveX2 ${CheckFormValid() ? "Valid" : "NotValid"}`} 
							disabled={!CheckFormValid()} onClick={() => SendFormData()}>Send message</button>
           			</div>
           		: 	<p className={`SpaceAboveX2 Valid BoldText TextCentre`}>Thanks, your message has been sent</p>}
        </div>
	)
}

export default ContactForm